import request from "@/utils/request";

export function addIndicators(data) {
  return request({
    url: "Indicators/AddIndicators",
    method: "post",
    data,
  });
}

export function getIndicators(data) {
  return request({
    url: "Indicators/GetIndicators",
    method: "post",
    data,
  });
}

export function updateIndicators(data) {
  return request({
    url: "Indicators/UpdateIndicators",
    method: "post",
    data,
  });
}



// WEBPACK FOOTER //
// ./src/api/indicators.js